import { BuildType } from '@/services/ApiService.ts';
import { LoginDemoResponse, LoginModel, UserModel, UserProfileModel } from '@/apiTypes/UserTypes.ts';
import { UserCustomTaskModel } from '@/ApiTypes.ts';
import { getCookie } from '@/lib/utils';
import { v4 as uuidv4 } from 'uuid';

export const userApiEndpoints = (build: BuildType) => ({
    getUser: build.query<UserModel, void>({
        query: () => `user?sessioncache=${getCookie('sessioncache') !== null ? getCookie('sessioncache') : uuidv4()}`,
        transformResponse: (response: UserModel) => response, // Pass through userWorkStates
        providesTags: ['User'],
    }),
    loginDemo: build.mutation<LoginDemoResponse, { loginModel: LoginModel }>({
        query: ({ loginModel }) => ({
            url: 'demo/login',
            method: 'POST',
            body: loginModel,
        }),
        invalidatesTags: ['User'],
    }),
    updateProfile: build.mutation<UserModel, { userProfile: UserProfileModel; userWorkStates?: string[] }>({
        query: ({ userProfile, userWorkStates }) => ({
            url: 'user/profile',
            method: 'PUT',
            body: userWorkStates !== undefined ? { userProfile, userWorkStates } : { userProfile },
        }),
        invalidatesTags: ['User', 'FeatureAccess'],
    }),
    getUserCustomTasks: build.query<UserCustomTaskModel[], void>({
        query: () => 'user/custom-tasks',
        providesTags: ['UserCustomTasks'],
    }),
    createOrUpdateUserCustomTask: build.mutation<UserCustomTaskModel, UserCustomTaskModel>({
        query: taskDetails => ({
            url: 'user/custom-tasks',
            method: 'POST',
            body: { taskDetails },
        }),
        invalidatesTags: ['UserCustomTasks'],
    }),
    deleteUserCustomTask: build.mutation<void, string>({
        query: id => ({
            url: `/user/custom-tasks/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['UserCustomTasks'],
    }),
});
